module.exports = __webpack_public_path__ + "icons/icon-link-2.a53ae7d1.svg";